import {regNavn} from "../tredjepartsTjenestenavn";
import moment from "moment";
import {Kontekst} from "../Kontekst";
import _ from "lodash";
import {BrukerRessurs} from "../ressurser/BrukerRessurs";
import {Debugger} from "debug";
import {IPromise, IQService} from "angular";

import {tz} from "moment-timezone"; //uten denne kompilerer ikke uttrykket moment.tz
require('moment-timezone');//utvider moment

const debuger = require('debug');
const debug:Debugger = debuger('Tidssonevalg');

export class Tidssonevalg {
    static regNavn = "Tidssonevalg";

    static forInjisering() {
        return [regNavn.ng.$log, regNavn.ng.$q, Kontekst.regNavn, BrukerRessurs.regNavn, Tidssonevalg];
    }

    constructor(private $log: ng.ILogService, private $q:IQService, private kontekst:Kontekst, private brukerRessurs:BrukerRessurs) {
        this._aktivTidssone = this.gjettFraNettleser();
    }

    private _aktivTidssone:string;

    /** Setter initiell tidssone, overstyres potensielt senere via kall til {@link #oppdaterFraKontekst} */
    initTidssone(){
        //ingen ting å gjøre her .. lener oss på nettleseren
    }

    /** Oppdaterer tidssone i bruk fra angitt kontekst, dvs fra tidssone satt på bruker */
    oppdaterFraKontekst(kontekst:Kontekst){
        const tidssone = kontekst.autentisertBruker().tidssone;
        if (!_.isEmpty(tidssone)) this.angiTidssone(tidssone);
    }

    /** Returnerer aktiv tidssone, på formen 'America/Los_Angeles' */
    aktivTidssone(): string {
        return this._aktivTidssone;
    }

    /** Returnerer aktiv tidssone, på en brukervennlig form, feks 'America/Los Angeles' */
    aktivTidssoneFormatert(): string {
        return Tidssonevalg.tidssoneFormatert(this._aktivTidssone);
    }

    /** Returnerer aktiv tidssone, på formen 'GMT' */
    aktivTidssoneAbbr(): string {
        const zone = moment.tz.zone(this._aktivTidssone);
        if (!_.isArray(zone?.abbrs) && (<string[]>zone.abbrs).length > 0) return '';
        return zone.abbrs[0];
    }

    /** Setter tiddssonene som skal brukes ved utskrift av klokkeslett. */
    angiTidssone(tidssone:string) :IPromise<any>{
        debug('angiTidssone', tidssone);

        if (moment.tz.zone(tidssone) === null) {
            this.$log.error(`Bruker forsøkte å sette ukjent tidssone: ${tidssone}. Beholder eksisterende tidssone: ${(<any>moment()).tz()}`);
            this.$q.reject();
        }
        moment.tz.setDefault(tidssone);
        this._aktivTidssone = tidssone;

        if (this.kontekst.erAutentisert() && this.kontekst.autentisertBruker().tidssone != tidssone) {
            this.kontekst.autentisertBruker().tidssone = tidssone;
            this.kontekst.autentisert().bruker.tidssone = tidssone;
            return this.brukerRessurs.oppdaterTidssone(tidssone).$promise;
        }

        return this.$q.resolve();
    }

    hentTilgjengeligeTidssoner(): IPromise<string[]> {
        return this.brukerRessurs.hentTilgjengeligeTidssoner().$promise
    }

    gjettFraNettleser() {
        return moment.tz.guess();
    }

    static tidssoneFormatert(tidssone:string):string{
        return _.defaultTo(tidssone, '').replace('_', ' ')
    }
}
